(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/ticket-id-popper/ticket-id-popper.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/ticket-id-popper/ticket-id-popper.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const isPlacementTopOrBottom = placement => {
  const topOrBottomPlacements = ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end'];
  return topOrBottomPlacements.includes(placement);
};
const UPDATE_DELAY = 1000;
const TicketIdPopper = _ref => {
  let {
    hasTicketNumber = false
  } = _ref;
  const {
    ticketInfo: {
      idPlacement: placement
    },
    isDemo: demo,
    betId: id,
    gameRef,
    isFullScreenGame
  } = svs.ticketgames.ticketUtility.components.useGameContext();
  const idRef = React.useRef(null);
  const popperInstanceRef = React.useRef(null);
  const createPopper = React.useCallback(() => {
    if (!idRef.current || !gameRef.current) {
      return;
    }
    const topHeader = document.querySelector('.js-fixed-top-content');
    popperInstanceRef.current = Popper.createPopper(gameRef.current, idRef.current, {
      placement: placement || 'right-end',
      modifiers: [{
        name: 'offset',
        options: {
          offset: _ref2 => {
            let {
              placement,
              popper
            } = _ref2;
            const offsetX = isPlacementTopOrBottom(placement) ? -popper.height : -popper.width;
            let offsetY = 0;
            if (hasTicketNumber && placement === 'right-start') {
              offsetY = 36; 
            }
            const offset = [offsetY, offsetX];
            return offset;
          }
        }
      }, {
        name: 'preventOverflow',
        options: {
          boundary: 'window',
          padding: {
            top: (topHeader === null || topHeader === void 0 ? void 0 : topHeader.clientHeight) || 0
          }
        }
      }]
    });
  }, [gameRef, idRef, id, hasTicketNumber, placement]);
  const updatePopper = React.useCallback(() => {
    if (!popperInstanceRef.current) {
      return;
    }
    const topHeader = document.querySelector('.js-fixed-top-content');
    popperInstanceRef.current.setOptions(options => _objectSpread(_objectSpread({}, options), {}, {
      modifiers: [...options.modifiers, {
        name: 'preventOverflow',
        options: {
          boundary: 'window',
          padding: {
            top: (topHeader === null || topHeader === void 0 ? void 0 : topHeader.clientHeight) || 0
          }
        }
      }]
    }));
    popperInstanceRef.current.update();
  }, []);
  const delayedUpdatePopper = React.useMemo(() => _.debounce(updatePopper, UPDATE_DELAY), [updatePopper]);
  React.useEffect(() => {
    createPopper();
    const events = [{
      eventName: 'GAME_LOADING',
      handler: delayedUpdatePopper
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: delayedUpdatePopper
    }, {
      eventName: 'HAS_CLAIMED',
      handler: delayedUpdatePopper
    }];
    events.forEach(_ref3 => {
      let {
        eventName,
        handler
      } = _ref3;
      return window.addEventListener(eventName, handler);
    });
    window.addEventListener('orientationchange', delayedUpdatePopper);
    delayedUpdatePopper();
    return () => {
      var _popperInstanceRef$cu;
      (_popperInstanceRef$cu = popperInstanceRef.current) === null || _popperInstanceRef$cu === void 0 || _popperInstanceRef$cu.destroy();
      events.forEach(_ref4 => {
        let {
          eventName,
          handler
        } = _ref4;
        return window.removeEventListener(eventName, handler);
      });
      window.removeEventListener('orientationchange', delayedUpdatePopper);
    };
  }, [createPopper, delayedUpdatePopper]);
  let idString = '';
  if (id) {
    idString = "ID ".concat(id);
  } else if (demo) {
    idString = 'PROVSPEL';
  } else {
    return null;
  }
  const classNames = ['ticket-id-popper'];
  if (!isFullScreenGame) {
    classNames.push('vertical-text');
  }
  return React.createElement("div", {
    className: classNames.join(' '),
    ref: idRef
  }, idString);
};
setGlobal('svs.ticketgames.ticketUtility.components.TicketIdPopper', TicketIdPopper);

 })(window);